import { authApi } from '@data-delivery/permission-ui-api';
import { useMutation } from '@tanstack/react-query';
import { clearCurrentUserRoles } from './current-user-roles.rq';

export function useLogoutMutation() {
  return useMutation({
    async mutationFn() {
      await authApi.logoutUser();
    },
    onSuccess() {
      // Clear all local user roles cache
      clearCurrentUserRoles();
    },
  });
}
